var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0833 6.78271C41.1884 6.78271 42.2482 7.2217 43.0296 8.0031C43.811 8.7845 44.25 9.84431 44.25 10.9494V40.116C44.25 41.2211 43.811 42.2809 43.0296 43.0623C42.2482 43.8437 41.1884 44.2827 40.0833 44.2827H10.9167C9.8116 44.2827 8.75179 43.8437 7.97039 43.0623C7.18899 42.2809 6.75 41.2211 6.75 40.116V10.9494C6.75 9.84431 7.18899 8.7845 7.97039 8.0031C8.75179 7.2217 9.8116 6.78271 10.9167 6.78271H40.0833ZM39.0417 39.0744V28.0327C39.0417 26.2315 38.3261 24.504 37.0524 23.2303C35.7787 21.9566 34.0513 21.241 32.25 21.241C30.4792 21.241 28.4167 22.3244 27.4167 23.9494V21.6369H21.6042V39.0744H27.4167V28.8035C27.4167 27.1994 28.7083 25.8869 30.3125 25.8869C31.086 25.8869 31.8279 26.1942 32.3749 26.7412C32.9219 27.2881 33.2292 28.03 33.2292 28.8035V39.0744H39.0417ZM14.8333 18.366C15.7616 18.366 16.6518 17.9973 17.3082 17.3409C17.9646 16.6845 18.3333 15.7943 18.3333 14.866C18.3333 12.9285 16.7708 11.3452 14.8333 11.3452C13.8996 11.3452 13.004 11.7162 12.3437 12.3764C11.6834 13.0367 11.3125 13.9323 11.3125 14.866C11.3125 16.8035 12.8958 18.366 14.8333 18.366ZM17.7292 39.0744V21.6369H11.9583V39.0744H17.7292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedIn-icon.29876183cff67ec5f440a8dcaca143f5.svg";
export { ForwardRef as ReactComponent };